import { render } from "./Vigik3.vue?vue&type=template&id=3a336bd4&scoped=true"
import script from "./Vigik3.vue?vue&type=script&lang=js"
export * from "./Vigik3.vue?vue&type=script&lang=js"

import "./Vigik3.vue?vue&type=style&index=0&id=3a336bd4&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a336bd4"]])

export default __exports__